import React from "react";
import { BrowserRouter as Router, Routes, Route, BrowserRouter } from "react-router-dom";
import ScrollToTop from "./component/ScrollToTop"; 
import CANavbar from "./component/navbar/CANavbar";
import Footer from "./component/footer/Footer";
import Home from "./component/home/Home";
import About from "./component/about/About";
import ServiceAccounting from "./component/services/ServiceAccounting";
import ServiceConsulting from "./component/services/ServiceConsulting";
import ServiceTds from "./component/services/ServiceTds";
import ServiceIndirectTaxation from "./component/services/ServiceIndirectTaxation";
import ServiceAuditAssurance from "./component/services/ServiceAuditAssurance";
import ServiceCorporate from "./component/services/ServiceCorporate";
import ServiceBusiness from "./component/services/ServiceBusiness";
import ServiceProfessionalGovernance from "./component/services/ServiceProfessionalGovernance"; 
import Gallery from "./component/gallery/Gallery";
import Contact from "./component/contact/Contact";

function App() {
  return (
    <BrowserRouter basename="/">
    
      <ScrollToTop />

      <CANavbar />

      {/* Main content container */}
      <div id="scrollable-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services/accounting" element={<ServiceAccounting />} />
          <Route path="/services/consulting" element={<ServiceConsulting />} />
          <Route path="/services/tds" element={<ServiceTds />} />
          <Route path="/services/indirect-taxation" element={<ServiceIndirectTaxation />} />
          <Route path="/services/audit-assurance" element={<ServiceAuditAssurance />} />
          <Route path="/services/corporate-governance" element={<ServiceCorporate />} />
          <Route path="/services/business-startup" element={<ServiceBusiness />} />
          <Route path="/services/professional-governance" element={<ServiceProfessionalGovernance />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>

        <Footer />
      </div>
    
    </BrowserRouter>
  );
}

export default App;
